import { KeyboardSensor, MouseSensor, PointerSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core'
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable'

/**
 * The sensors every list of these rows drags with: a pointer that has to
 * travel 6px first, so a click on the handle is still a click, and the
 * keyboard (space to lift, arrows to move, space to drop).
 *
 * `holdOnTouch` is for lists whose rows drag from anywhere: a finger has to
 * rest on the row a moment before it lifts, so a swipe across the rows still
 * scrolls. The mouse keeps its 6px; the two replace the one pointer sensor,
 * which cannot tell them apart.
 */
export const useSortableRowSensors = ({ holdOnTouch = false }: { holdOnTouch?: boolean } = {}) => {
	const pointer = useSensor(PointerSensor, { activationConstraint: { distance: 6 } })
	const mouse = useSensor(MouseSensor, { activationConstraint: { distance: 6 } })
	const touch = useSensor(TouchSensor, { activationConstraint: { delay: 200, tolerance: 6 } })
	const keyboard = useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
	return useSensors(holdOnTouch ? null : pointer, holdOnTouch ? mouse : null, holdOnTouch ? touch : null, keyboard)
}
